import React from "react";
import Chip from "@mui/material/Chip";
import { styled } from "@mui/system";
import { useSelector } from "react-redux";

const CoreChip = ({ ...props }) => {
  const colorPrimary = useSelector((state) => state.app.primaryColor);
  const colorSecondary = useSelector((state) => state.app.secondaryColor);
  const globalFilters = useSelector((state) => state.globalFilters);

  const colorChip = Object.values(globalFilters).some((v) => v !== "")
    ? "#1d4ed8"
    : colorPrimary;

  const MyChip = styled(Chip)({
    "&.MuiChip-root": {
      borderColor: colorChip,
      color: colorChip,
      "& .MuiChip-deleteIcon": {
        color: colorChip,
      },
    },
  });

  return <MyChip {...props} />;
};

export default CoreChip;
